module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C415"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("How to use this book")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("This book has been a number of years in the making, and stems from our desire to provide a book which can provide the basis of an introductory course on the New Testament (NT) Gospels and Acts for first- or second-year students in a university, theological college or seminary; a companion volume is available on the NT Letters and the book of Revelation. Typically, we have in mind a one-term or one-semester course which is a mixture of lecture input and seminar-based discussion, and both of us have taught such courses in India, Oxford, Bedford, Nottingham, Bristol and London. This section aims to help you, whether a teacher or a student, to get the most from our book.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("This book is also intended for use by those reading and studying outside a college setting, whether as part of a distance-learning course or simply because you want to learn about the NT. There are various ways of approaching this book. You may like to work from beginning to end, or to dip into particular sections. Some will like to get into the NT text quickly, and if so we suggest that you may like to begin either")]), _vm._v(" "), _c('div', {
    staticClass: "C464"
  }, [_c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("with "), _c('span', {
    attrs: {
      "href": "#/Text/19_9Mark#page_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")]), _vm._v(" on Mark’s Gospel and then go on to "), _c('a', {
    attrs: {
      "href": "#/Text/08_1The_historical_context_of_Jesus#page_3"
    }
  }, [_vm._v("Chapters 1")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/09_2Judaism_in_first_century_Palest#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" on the historical and Jewish contexts of the Gospels and Acts; or")]), _vm._v(" "), _c('p', {
    staticClass: "C460"
  }, [_c('span', {
    staticClass: "C432"
  }, [_vm._v("•")]), _vm._v("with "), _c('a', {
    attrs: {
      "href": "#/Text/08_1The_historical_context_of_Jesus#page_3"
    }
  }, [_vm._v("Chapters 1")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/09_2Judaism_in_first_century_Palest#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" on contexts before going on to "), _c('span', {
    attrs: {
      "href": "#/Text/19_9Mark#page_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")]), _vm._v(" on Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_vm._v("Either way, you will then be well placed to read other parts of the book. Sections B ‘Approaching the Gospels’ and C ‘Understanding Jesus’ can be read independently of each other, although the chapters within each section are designed to be read in sequence (B: Chs 3 to 5; C: Chs 6 to 8).")])]), _vm._v(" "), _c('p', {
    staticClass: "C453"
  }, [_c('strong', [_vm._v("Our aims and objectives")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("We are particularly concerned to get students reading and engaging with the Gospels and Acts for themselves, rather than simply learning at second hand what these books say or merely absorbing a lot of interesting theories about them. So in our chapters we have endeavoured to provide enough references to the Gospels and Acts, and other pertinent ancient literature, so that students can read the texts alongside our discussion. We have also built into each chapter four sorts of further study for students to pursue, many of which we have used ourselves in the classroom.")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('strong', [_vm._v("What do you think?")]), _vm._v(" boxes provide questions and issues that we estimate will take 30-60 minutes for a typical student, and might then be used as the basis of a brief class discussion, perhaps in small groups if the class is too large to discuss all together.")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('strong', [_vm._v("Digging deeper")]), _vm._v(" boxes offer a piece of research which will take 2–3 hours of private study, and which could form the basis of a one-hour "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("seminar class led by the teacher or by some of the students. Having two or three students lead such a discussion, in our experience, enables the student leaders to engage with the topic at greater depth, since they must set the agenda for the seminar, and also enables students to debate views with each other in a way that facilitates learning. Sometimes we have suggested how a seminar hour might be structured to handle the topic.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("In the second edition of this book we introduced boxes called "), _c('strong', [_vm._v("Focus on theology")]), _vm._v(". These boxes are varied in content and include summaries of key theological emphases of an NT book or section, reflection on the wider theological interpretation of a theme or topic, consideration of implications for faith and life today based on the NT material being studied, or questions to provoke readers to engage in this kind of reflection. These are designed both to model how the NT can be read theologically, and to encourage our readers to do their own theological reading of the NT (see "), _c('span', {
    attrs: {
      "href": "#/Text/13_5Understanding_the_Gospels_today#page_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pp. 128")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/19_9Mark#page_229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("229")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/20_10Matthew#page_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("253")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/21_11Luke#page_278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("278")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/22_12John#page_297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("297")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/24_13Acts#page_321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("321")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('strong', [_vm._v("Essay topics")]), _vm._v(" at the end of each chapter or section provide ideas on topics to research at more depth, which are to be presented in written form. They are intended to be about 2,500-3,000 words in length, although a number could be longer (or a little shorter if the course being taught required that). Some are identified as ‘Introductory’, and are intended for first-year students, and some as ‘Intermediate’, which are intended for second years.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("In each case, there are too many for a student to do all of them, and the teacher will need to select those which best fit the particular aims and objectives of the course being taught, or to guide students in their choice of which to pursue. And we hope that our suggestions will stimulate teachers to add their own good ideas!")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('strong', [_vm._v("Further reading")]), _vm._v(" lists at the end of each chapter or section provide a basis for the research on the essay topics, as well as for further study in greater depth on particular issues within each section of the book, and we have chosen books which are generally available in European and North American college and university libraries. Within each chapter we have referred to books by the ‘author and date’ system (e.g. Wright 1996), and full publication details can be found in the ‘Further reading’ sections. Where a book has a British and an American edition, we have endeavoured to provide place of publication and publisher for both editions.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Because many students studying the Gospels and Acts are Christians, as we ourselves are, and will therefore want to ask about the relevance of their studies to living as Christians today, we have provided occasional sections called "), _c('strong', [_vm._v("Some issues for today")]), _vm._v(" which sketch some of our thoughts in the light of our studies. These are designed to be jumping-off points and models to encourage students (and teachers) to make their own connections between then and now.")]), _vm._v(" "), _c('p', {
    staticClass: "C453"
  }, [_c('strong', [_vm._v("Structure of the book")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("The book falls into five sections: first, we set out the key contexts, historical and religious, within which the lives of Jesus and the early churches need to be seen. Here, we focus on the Jewish contexts; the companion volume on the "), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("NT Letters and Revelation will set the Graeco-Roman context, which is more relevant to those NT books.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Second, we outline methods of study used in approaching the Gospels, including the question of the kind of literature that they are, their origins and how to interpret the Gospels today.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Third, we focus on the main figure of the Gospels, Jesus himself. After surveying scholarly study of Jesus over the last 150 years or so and highlighting key issues, we outline what can be known of the life of Jesus from historical study, and then look at the major points of his teaching and his aims.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Fourth, we study each of the Gospels in turn, beginning with Mark. We start here because Mark is the shortest and is usually held to be the first; this allows our chapters on Matthew and Luke to focus on the distinctive contributions of these Gospels. The chapter on John is rather longer because John ‘stands apart’ from the others in his style and presentation of Jesus. Each chapter looks at the contents, structure, major themes and emphases of each Gospel, with a brief consideration of who wrote each book and when.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("Finally, we study Acts, the continuation of the story into the life of the earliest Christians, again considering its contents, organization, major themes and emphases, as well as discussing modern debates about Acts, including its authorship and date.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("A "), _c('strong', [_vm._v("glossary")]), _vm._v(" at the end provides references to the main places in our book where key technical terms and words are introduced and explained, particularly in boxes within the chapters.")]), _vm._v(" "), _c('p', {
    staticClass: "C453"
  }, [_c('strong', [_vm._v("Who wrote what?")])]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_vm._v("We have planned this book together (and also with Stephen Travis, Ian Paul and Howard Marshall, who have written the companion volume on the NT letters and Revelation), and both of us have read and commented on the other’s drafts of chapters and sections. So while we share responsibility for the whole book, the following chapters/sections were the particular responsibility of each of us:")]), _vm._v(" "), _c('p', {
    staticClass: "C399"
  }, [_c('strong', [_vm._v("David Wenham")]), _vm._v(": Chs 1, ‘What about other Gospels?’ (part of 3), 5 (except "), _c('span', {
    attrs: {
      "href": "#/Text/13_5Understanding_the_Gospels_today#page_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pp. 93–119")]), _vm._v("), 6, 7, 10 and 12.")]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_c('strong', [_vm._v("Steve Walton")]), _vm._v(": Chs 2, 3 (except for ‘What about other Gospels?’), 4, ‘Tools for interpreting the Gospels’ and ‘An approach to exegesis of the Gospels’ (part of 5), 8, 9, 11 and 13.")]), _vm._v(" "), _c('p', {
    staticClass: "C453"
  }, [_c('strong', [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Both of us are very grateful to our students over the years, who have experienced much of this material at first hand, and whose feedback has led to it being better than it might have been. We have also valued our collaboration with Stephen Travis (in whose mind the two-volume project came to birth), Ian Paul and Howard Marshall, as well as the fine help of Robin Keeley, Ruth McCurry, Phillip Law and Mary Matthews of SPCK. David Wenham would like to acknowledge the help of his former colleague in Oxford, Dr Jeremy Duff, Dr Cornelis Bennema of Union Theological College for his advice on recent Johannine studies, and the constant support of his wife, Clare. We are very grateful to her for preparing the index for the book.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("Steve Walton has valued the opportunity to teach alongside (and sometimes with) colleagues in Bristol, Nottingham and London who have contributed to his thinking, particularly Stephen Travis, Colin Hart, Max Turner and Conrad Gempf: a number of their ideas are likely to have influenced my chapters. Prof. James Edwards of Whitworth College, Spokane, WA kindly commented on a draft of "), _c('span', {
    attrs: {
      "href": "#/Text/19_9Mark#page_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ch. 9")]), _vm._v(", Dr Elizabeth Shively of the University of St Andrews advised on recent publications on Mark, and the Rev. Rob Bewley of the University of Cambridge on a draft of "), _c('span', {
    attrs: {
      "href": "#/Text/17_8The_teaching_and_aims_of_Jesus#page_181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ch. 8")]), _vm._v(". Last, but by no means least, I cannot overstate the importance of the love, support and encouragement of Ali, my wife, without whom this book would never have come to birth.")]), _vm._v(" "), _c('p', {
    staticClass: "C453"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_249"
    }
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("Generally, we have used the abbreviations in Billie Jean Collins, Bob Buller and John F. Kutsko, eds. "), _c('em', [_vm._v("The SBL Handbook of Style for Ancient Near Eastern, Biblical and Early Christian Studies")]), _vm._v(". 2nd ed. Atlanta: SBL, 2014, "), _c('span', {
    attrs: {
      "href": "#/Text/17_8The_teaching_and_aims_of_Jesus#page_181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ch. 8")]), _vm._v(".. We list below the main abbreviations used.")]), _vm._v(" "), _c('table', {
    staticClass: "C619",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "T369_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("ABD")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("David N. Freedman, ed. "), _c('em', [_vm._v("Anchor Bible Dictionary")]), _vm._v(" (6 vols). New York: Doubleday, 1992.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T369_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("AJT")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("American Journal of Theology")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T369_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("Ag. Ap.")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Josephus, "), _c('em', [_vm._v("Against Apion")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T369_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("Ant")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Josephus, Antiquities")])]), _vm._v(" "), _c('tr', {
    staticClass: "T369_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("DJG2")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Joel B. Green, Jeannine K. Brown and Nicholas Perrin, eds. "), _c('em', [_vm._v("Dictionary of Jesus and the Gospels")]), _vm._v(", revised ed. Nottingham/ Downers Grove: IVP, 2012.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("DLNTD")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Ralph P. Martin and Peter H. Davids, eds., "), _c('em', [_vm._v("Dictionary of the Later New Testament and its Developments.")]), _vm._v(" Leicester/ Downers Grove: IVP, 1997.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("DNTB")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Craig A. Evans and Stanley E. Porter, eds., "), _c('em', [_vm._v("Dictionary of New Testament Background")]), _vm._v(". Leicester/Downers Grove: IVP, 2000.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("DPL")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Gerald F Hawthorne, Ralph P. Martin and Daniel G. Reid, eds., "), _c('em', [_vm._v("Dictionary of Paul and his Letters.")]), _vm._v(" Leicester/Downers Grove: IVP, 1993.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("DPL2")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Scot McKnight, Lynn H. Cohick and Nijay K. Gupta, eds. Dictionary of Paul and his Letters. 2nd ed. Downers Grove, IL: IVP, 2022.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("Hist. eccl.")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Eusebius, "), _c('em', [_vm._v("Ecclesiastical History")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("JW")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Josephus, "), _c('em', [_vm._v("Jewish War")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("LCL")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Loeb Classical Library")])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("Life")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Josephus, "), _c('em', [_vm._v("The Life of Flavius Josephus")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("LXX")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Septuagint")])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("NDBT")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("T. Desmond Alexander and Brian S. Rosner, eds., "), _c('em', [_vm._v("New Dictionary of Biblical Theology")]), _vm._v(". Leicester/Downers Grove: IVP, 2000.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("NIV")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("New International Version")])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("NRSV")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("New Revised Standard Version")])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_vm._v("RSV")]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Revised Standard Version")])]), _vm._v(" "), _c('tr', {
    staticClass: "T370_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("ZNW")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('em', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_vm._v("A note on Josephus references")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("The works of Josephus have two widely used reference systems, one found in Whiston’s translation (dividing his works into books, chapters and verses) and the other found in the Loeb Classical Library edition (dividing his works simply into books and verses). We "), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v("have normally used the Loeb edition for our quotations, but we have given both types of reference when we have referred to Josephus, so that you should be able to find the reference whichever edition you use.")]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_vm._v("A note on further reading")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("A number of standard reference books can be recommended for following up most of the topics covered in this book. As a first step students are encouraged to look up the relevant articles on the NT documents in dictionaries such as "), _c('em', [_vm._v("ABD, DJG2")]), _vm._v(" and "), _c('em', [_vm._v("DLNTD")]), _vm._v(" (see "), _c('a', {
    attrs: {
      "href": "#/Text/06_How_to_use_this_book#id_249"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" above). On certain topics, "), _c('em', [_vm._v("DNTB")]), _vm._v(" and "), _c('em', [_vm._v("NDBT")]), _vm._v(" will be useful.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The amount of modern literature on the Gospels and Acts is enormous. This applies especially to commentaries, where there is no way that we can list all the useful works on any of the NT books. What we have done is to mention those works that we happen to have found personally helpful without implying that those that we haven’t mentioned are somehow inferior. In order to avoid repetition of the same comments it may be helpful here to list a number of commentary series and offer a brief characterization of each. ‘Exegetical’ and ‘exegesis’ refer to trying to understand what the text would have meant to its original readers; ‘expository’ and ‘exposition’ refer to trying to explain the significance that the text might have for readers today.")]), _vm._v(" "), _c('p', {
    staticClass: "C456"
  }, [_vm._v("The descriptions below begin with the abbreviation for each series used in the rest of this book. More specialized, technical works and works that require a knowledge of Greek are marked with an asterisk both here and in the bibliographies.")]), _vm._v(" "), _c('table', {
    staticClass: "C619",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "T371_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("AB")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Anchor Bible")]), _vm._v(" Ongoing series of full commentaries using Greek in transliteration, generally providing detailed notes followed by explanatory discussion of each passage. Earlier volumes in the series were of unequal quality; more recent ones are very good but some tend to excessive length.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T371_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("ACCS")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Ancient Christian Commentary on Scripture")]), _vm._v(" Valuable collections of verse-by-verse comment from the early Christian fathers, making their readings of biblical books more easily accessible.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T371_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("ANTC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Abingdon NT Commentary")]), _vm._v(" Intended to provide ‘compact critical commentaries’ catering to the needs of students and preachers.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T371_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("*BECNT")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Baker Exegetical Commentary on the NT")]), _vm._v(" Detailed commentaries working with the Greek, but generally accessible for those who do not have Greek.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T371_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("BNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Black’s NT Commentaries")]), _vm._v(" Middle-length, non-technical exegesis of high quality (this series is known in North America as Harpers NT Commentaries).")])]), _vm._v(" "), _c('tr', {
    staticClass: "T371_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("BST")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("The Bible Speaks Today")]), _vm._v(" Expository commentaries with varying amounts of detail; useful for preachers.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T371_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("CCSS")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Catholic Commentary on Sacred Scripture")]), _vm._v(" Concise commentaries in the Catholic tradition, with some modern application.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T371_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("EBC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("The Expositor’s Bible Commentary")]), _vm._v(" Multi-volume series on the whole")])]), _vm._v(" "), _c('tr', {
    staticClass: "T372_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Bible now in a thoroughly revised second edition.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T372_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("EC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Epworth Commentaries")]), _vm._v(" Short commentaries that have some concern for modern application.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T372_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("*ECC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Eerdmans Critical Commentary")]), _vm._v(" New series offering detailed exegesis based on the Greek text.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T372_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("HCNT")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Hellenistic Commentary to the New Testament")]), _vm._v(" Annotated collection of about 1,000 parallels from the ancient (mainly Graeco-Roman) world to NT texts, illustrating similarities and differences.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T372_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("*Herm")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Hermeneia")]), _vm._v(" Detailed technical commentaries on the Greek text.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T372_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("*ICC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("International Critical Commentary")]), _vm._v(" Full-scale treatments of the Greek text. Older, nineteenth- and twentieth-century volumes are now being replaced by fresh volumes.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T372_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Int")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Interpretation")]), _vm._v(" Middle-length commentaries specifically designed to be helpful to preachers.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T372_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("IVPNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("InterVarsity Press New Testament Commentaries")]), _vm._v(" Similar to BST in bringing out the contemporary relevance of the text, but with a greater emphasis on the basic exegesis.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T372_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("LCL")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T372_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("NAC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("New American Commentary")]), _vm._v(" Multi-volume series, aiming to be exegetical and expository; largely from a conservative and Baptist background.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T372_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("NBBC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("New Beacon Bible Commentary")]), _vm._v(" Multi-volume series in the")])]), _vm._v(" "), _c('tr', {
    staticClass: "T373_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Wesleyan/Nazarene tradition with sections on ‘Behind the Text’, ‘In the Text’ and ‘From the Text’.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T373_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("NCB")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("New Century Bible")]), _vm._v(" Very similar to BNTC but generally less detailed.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T373_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("NCBC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("New Cambridge Bible Commentary")]), _vm._v(" Short commentaries using insights of rhetorical, narrative and socio-scientific criticism.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T373_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("NCCS")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("New Covenant Commentary Series")]), _vm._v(" A lively series of shorter commentaries written by a diverse set of international authors, and with an eye to relevance to today’s church around the world.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T373_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("NIB")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("The New Interpreter’s Bible")]), _vm._v(" Vols. VIII-XII cover the NT with full-scale treatments providing ‘overviews’ and both ‘commentary’ (exegesis) and ‘reflections’ (help for preachers).")])]), _vm._v(" "), _c('tr', {
    staticClass: "T373_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("NIBC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("New International Biblical Commentary")]), _vm._v(" Entrance-level commentaries, some of which are more useful for out-and-out beginners while others contain good material for students.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T373_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("NIC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("New International Commentary")]), _vm._v(" Middle-length exegesis with technicalities relegated to footnotes. Weaker, earlier volumes now replaced by first-class recent volumes.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T373_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("*NIGTC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("New International Greek Testament Commentary")]), _vm._v(" Detailed commentaries on the Greek text; less technical than ICC.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T373_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("NIVAC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("NIV Application Commentary")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T374_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_vm._v("Offering a combination of exegesis and application linked together by a ‘bridge’ between then and now.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T374_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("NTL")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("New Testament Library")]), _vm._v(" Good on cultural context and theological exposition.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T374_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Paideia")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Paideia Commentaries on the NT")]), _vm._v(" Reader-friendly series attending to authors’ rhetorical strategies and theological significance for today.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T374_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("PNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Pillar NT Commentary")]), _vm._v(" Careful blend of exegesis and exposition.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T374_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("RCS")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Reformation Commentary on Scripture, NT series")]), _vm._v(" Helpful compilations of comments from Reformation era writers on a biblical book, providing easy access to this valuable material.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T374_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("SGBC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Story of God Bible Commentary")]), _vm._v(" Leading scholars explain the text and debated issues, and then reflect on the text’s implications for today’s church and world.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T374_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("SP")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Sacra Pagina")]), _vm._v(" Insightful commentaries by scholars from the Catholic tradition.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T374_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("THNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Two Horizons NT Commentary")]), _vm._v(" Interpretations in relation to concerns of systematic theology.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T374_Row"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("TNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Tyndale New Testament Commentaries")]), _vm._v(" Introductory-level commentaries providing the essential exegetical help.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T374_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("WBBC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Wiley Blackwell Bible Commentaries")]), _vm._v(" A series focused on the reception and impact of the biblical book throughout history, each entitled "), _c('em', [_vm._v("...through the Centuries")]), _vm._v(".")])]), _vm._v(" "), _c('tr', {
    staticClass: "T375_FirstRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("*WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Word Biblical Commentary")]), _vm._v(" Detailed commentaries using Greek quite widely; less technical than ICC.")])]), _vm._v(" "), _c('tr', {
    staticClass: "T375_LastRow"
  }, [_c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("*ZECNT")])]), _vm._v(" "), _c('td', {
    staticClass: "C621"
  }, [_c('strong', [_vm._v("Zondervan Exegetical Commentary on the NT")]), _vm._v(" A helpful and accessible mid-level series, engaging with the Greek but not highly technical.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C471"
  }, [_vm._v("Several one-volume commentaries cover the whole Bible or the NT:")]), _vm._v(" "), _c('p', {
    staticClass: "C470"
  }, [_vm._v("John Barton and John Muddiman, eds. "), _c('em', [_vm._v("The Oxford Bible Commentary")]), _vm._v(". Oxford: Oxford University Press, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "C470"
  }, [_vm._v("James D. G. Dunn and John W. Rogerson, eds. "), _c('em', [_vm._v("Eerdmans Commentary on the Bible.")]), _vm._v(" Grand Rapids: Eerdmans, 2003. (This and the previous title are two very similar works that attempt to express the state of biblical scholarship at the beginning of the new millennium.)")]), _vm._v(" "), _c('p', {
    staticClass: "C470"
  }, [_vm._v("Greg K. Beale and Don A. Carson, eds. "), _c('em', [_vm._v("Commentary on the New Testament Use of the Old Testament")]), _vm._v(". Grand Rapids: Baker Academic/ Nottingham: Apollos, 2007. (Very detailed, at times technical, treatment of the quotations from, allusions to and echoes of the OT in the NT.)")]), _vm._v(" "), _c('p', {
    staticClass: "C470"
  }, [_vm._v("Don A. Carson et al., eds. "), _c('em', [_vm._v("The New Bible Commentary: 21st Century Edition")]), _vm._v(". Leicester/ Downers Grove: IVP, 1994. (Introductory level with more emphasis on explanation of the text than the Eerdmans and Oxford counterparts; unlike them does not include Apocrypha.)")]), _vm._v(" "), _c('p', {
    staticClass: "C468"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v("Online resources")])]), _vm._v(" "), _c('p', {
    staticClass: "P0"
  }, [_vm._v("We have put together a website <"), _c('a', {
    attrs: {
      "href": "http://exploringthenewtestament.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("http://exploringthenewtestament.co.uk")]), _vm._v("> which provides material to supplement this book and its companion on the letters and Revelation. There we provide relevant photographs, copies of our diagrams, useful ancient texts and sources, links to helpful and reliable web resources, and much else. All of these resources are easily downloadable, and can be used by teachers (and students) in sets of slides or handouts. The website is organised by the chapters of the two "), _c('em', [_vm._v("Exploring the New Testament")]), _vm._v(" books, and is also searchable by topic. If you come across resources which it would be helpful to add to the website, please email us at "), _c('a', {
    attrs: {
      "href": "mailto:info@exploringthenewtestament.co.uk"
    }
  }, [_vm._v("info@exploringthenewtestament.co.uk")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c71f5f34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/06_How_to_use_this_book.vue
// module id = 69
// module chunks = 0